import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasVendor from './aidas-vendor';
import AidasVendorDetail from './aidas-vendor-detail';
import AidasVendorUpdate from './aidas-vendor-update';
import AidasVendorDeleteDialog from './aidas-vendor-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasVendorUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasVendorUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasVendorDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasVendor} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasVendorDeleteDialog} />
  </>
);

export default Routes;
